<template>
    <div class="machine-wrapper">
        <span v-if="machine.has_data_display && canAccessMachineDisplay">
            <a class="machine-name machine-has-data-display" :href="'/machine-production-control/' + machine.id">
            {{ machine.descrip }}
            </a>
        </span>
        <span v-else class="machine-name">
            {{ machine.descrip }}
        </span>
        <b-button variant="secondary" :class="['active-machine-button']" @click="handleActiveMachine" v-if="machine.topics.length > 0 && canMonitorizeMachineData">Live</b-button>
    </div>
</template>

<script>

import { mapActions, mapGetters} from "vuex";
import PermissionsConsts from "../../common/permissions";

export default {
    name: "Machine",
    props:{
        machine:Object,
        productionLineCollapseId: String
    },
    data(){
        return{
            isLive:false
        }
    },
    methods:{
        ...mapActions('monitorization', ['createActiveMachine', 'deleteActiveMachine']),
        handleActiveMachine(){
            var self = this;

            if(!self.isLive) self.createActiveMachine({id: self.machine.id, machine:{code: self.machine.code}})
            else self.deleteActiveMachine(self.machine.id)

            self.isLive = !self.isLive;
        }
    },
    computed: {
        ...mapGetters(['userPermissions','userHasPermission']),
        canMonitorizeMachineData(){
            return this.userHasPermission(PermissionsConsts.PRODUCTION_MONITORIZATION_MACHINE_DATA_GET);
        },
        canAccessMachineDisplay(){
            return this.userHasPermission(PermissionsConsts.PRODUCTION_MACHINE_CONTROL_VIEW);
        },
    },
    mounted(){
        let self = this;
        this.$root.$on('bv::collapse::state', (collapseId, isOpening) => {
            if(collapseId == self.productionLineCollapseId && !isOpening) self.isLive = false;
        })
    }
}
</script>